import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect, useContext } from "react";
import { connect } from "react-redux";
import { getProducts } from "../../helpers/product";
import ProductGridSingle from "../../components/product/ProductGridSingle";
import { addToCart } from "../../redux/actions/cartActions";
import { addToWishlist } from "../../redux/actions/wishlistActions";
import { addToCompare } from "../../redux/actions/compareActions";
import { getTagProducts, fetchProducts, isLoading } from "../../redux/actions/productActions"
import axios from "axios"
import { X_TENANT_ID } from '../../common/ActionUrl'
import { AuthContext } from "../../common/Auth"
import { getISODate } from "../../common/DateFomatter";

const ProductGrid = ({
  fetchProducts,
  featuredProducts,
  currency,
  addToCart,
  addToWishlist,
  addToCompare,
  cartItems,
  wishlistItems,
  compareItems,
  sliderClassName,
  spaceBottomClass,
  getTagProducts,
  tabProductCat,
  ownProps,
  props,
  productSliderSettings,
  isTab,
  tagName
}) => {

  const { themeSettingsData, userPoints, login,userGroupDiscount } = useContext(AuthContext)
  const [tagCatData, setTagCatData] = useState([])
  const [toggle, setToggle] = useState(true)
  const [loading, setLoading] = useState(false)
  let getHasTag = null

  useEffect(() => {
    setLoading(true)
    if (tabProductCat && tabProductCat != "") {
      const requestOptions = {
        headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID },
      }
      let data = {
        "isDeleted": 0,
        "limit": ownProps.limit,
        "offset": 0,
        "order": "productName",
        "orient": "asc",
        "categories": [],
        "tags": [],
        "colors": [],
        "sizes": [],
        "query": "",
        "productTagId": tabProductCat
      }
      let url = "/api/v1/front/products";

      axios.post(url, data, requestOptions)
        .then((res) => {
          setLoading(false)
          if (res.data && res.data.results.length > 0) {
            const response = res.data;
            const listData = response.results.map(dataArray => {
              return (dataArray);
            });
            setTagCatData(listData)
          }
        }).catch(err => {
          setLoading(false)
          console.log('err', err);
        });
    } 
    // else {

    //   let data = {
    //     "isDeleted": 0,
    //     "limit": ownProps.limit,
    //     "offset": 0,
    //     "order": "productName",
    //     "orient": "asc",
    //     "categories": [],
    //     "tags": [],
    //     "colors": [],
    //     "sizes": [],
    //     "productName": "",
    //     "isFeatured": true
    //   }
    //   getTagProducts(ownProps.limit, 0, "productName", "asc", data)
    // }
  }, [])

  useEffect(() => {
    if(productSliderSettings && productSliderSettings.productTabs){
      getTagProducts(ownProps.limit, 0, "productName", "asc", { "isFeatured": true,"tags":[{"_id":productSliderSettings?.productTabs ? productSliderSettings?.productTabs : "" }] })
    }
  }, [productSliderSettings])

  let productData = []
  useEffect(() => {
    setToggle(!toggle)
  }, [tagCatData])
  if (tagCatData.length > 0) {
    productData = tagCatData;
  } else if (featuredProducts && featuredProducts.length > 0) {
    productData = featuredProducts;
  }

  return (
    <Fragment>
      {productData && productData.map(product => {
        getHasTag = product?.productTags && product?.productTags.length > 0 && product?.productTags.filter((adad) => adad?.name == tagName?.tagName)
        product.startDate  = getISODate(product?.startDate);
        product.endDate  = getISODate(product?.endDate);
        return ( getHasTag && getHasTag.length > 0 &&
          <ProductGridSingle
            setToggle={setToggle}
            toggle={toggle}
            sliderClassName={sliderClassName}
            spaceBottomClass={spaceBottomClass}
            product={product}
            currency={currency}
            addToCart={addToCart}
            addToWishlist={addToWishlist}
            addToCompare={addToCompare}
			isTab={isTab}
            cartItem={
              cartItems?.filter(cartItem => cartItem.id === product.id)?.[0]
            }
            wishlistItem={
              wishlistItems.filter(
                wishlistItem => wishlistItem.id === product.id
              )[0]
            }
            compareItem={
              compareItems.filter(
                compareItem => compareItem.id === product.id
              )[0]
            }
            key={product.id}
          />
        );
      })}
      { getHasTag && getHasTag.length == 0 && loading == false && <p style={{width:"100%", textAlign:"center", marginBottom:"16px"}}>No data found</p>}
    </Fragment>
  );
};

ProductGrid.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  cartItems: PropTypes.array,
  compareItems: PropTypes.array,
  currency: PropTypes.object,
  featuredProducts: PropTypes.array,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  wishlistItems: PropTypes.array,
  isTab:PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
  return {
    featuredProducts: state.productData.tagProducts,
    ownProps: ownProps,
    currency: state.currencyData,
    cartItems: state.cartData.cartItems,
    wishlistItems: state.wishlistData,
    compareItems: state.compareData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addToCart: (
      item,
      _addToast,
      quantityCount,
      selectedProductColor,
      selectedProductSize,
      selectedProductDecorations,
      personalizationArray,
      personalizationCost,
      userGroupDiscount
    ) => {
      dispatch(
        addToCart(
          item,
          _addToast,
          quantityCount,
          selectedProductColor,
          selectedProductSize,
          selectedProductDecorations,
          personalizationArray,
          personalizationCost,
          userGroupDiscount
        )
      );
    },
    addToWishlist: (item, _addToast, wishlistRelabel = 'Wishlist') => {
      dispatch(addToWishlist(item, _addToast, wishlistRelabel));
    },
    addToCompare: (item, _addToast) => {
      dispatch(addToCompare(item, _addToast));
    },
    getTagProducts: (limit, offset, order, orient, filter) => {
      dispatch(getTagProducts(limit, offset, order, orient, filter));
    },
    fetchProducts: (limit, offset, order, orient, filter) => {
      dispatch(fetchProducts(limit, offset, order, orient, filter));
    },
    isLoading: (loading) => {
      dispatch(isLoading(loading));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductGrid);
